class utils {
  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase())
	}

	delay (s) {
		return new Promise(function(resolve,reject){
		 setTimeout(resolve,s)
		})
	}
}

export default new utils()


// WEBPACK FOOTER //
// ./src/utils/utils.js